import { render } from "./AIMLItsBlogsComp.vue?vue&type=template&id=5359f8dc&scoped=true"
import script from "./AIMLItsBlogsComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsBlogsComp.vue?vue&type=script&lang=js"

import "./AIMLItsBlogsComp.vue?vue&type=style&index=0&id=5359f8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5359f8dc"]])

export default __exports__